import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Group, Image, NumberFormatter, Text, rem } from '@mantine/core';
export type WalletBalanceProps = {
  balance: number;
  pnl: number;
};
export const WalletBalance: React.FC<WalletBalanceProps> = ({
  balance,
  pnl
}) => {
  const {
    i18n
  } = useLingui();
  return <Group gap={40} mt={20} pos="relative">
      <Image src="/assets/wallet/whale.svg" alt="whale" w={149} h={149} pos="absolute" top={rem(-50)} right={rem(-60)} visibleFrom="sm" />

      <Box>
        <Text fz={12} fw={700} c="var(--text-prime)" tt="uppercase">
          {i18n._('Balance')}
        </Text>
        <Text fz={21}>
          <NumberFormatter prefix="$" value={balance} className={gunterzBold.className} thousandSeparator="," />
        </Text>
      </Box>

      <Box>
        <Text fz={12} fw={700} c="var(--text-dark)" tt="uppercase">
          {i18n._('30D')}
        </Text>
        <Text fz={21} c="var(--text-green)">
          <NumberFormatter suffix="%" prefix="+" value={pnl} decimalSeparator="." thousandSeparator="," decimalScale={2} fixedDecimalScale className={gunterzBold.className} />
        </Text>
      </Box>
    </Group>;
};